import React, { useCallback, useMemo, useState } from "react";
import { ChildrenProps } from "../Models/componentModel";
import agent from "../service/api";
import { CreateNewResourcePayload, UpdateResourcePayload, UploadResourcePayload } from "../Models/axiosModel";

const TrainingContext = React.createContext<TrainingContextPayload | undefined>(undefined);
export interface SelectedResourceDataType {
    "resource_id"?: number | null,
    "resource_created_by_user_id"?: number | null,
    "resource_created_at_timestamp"?: string,
    "resource_title"?: string,
    "resource_description"?: string,
    "resource_file_data"?: [
        {
            "file_id"?: number | null,
            "file_name"?: string,
            "file_url"?: string,
            "file_size"?: string,
            "file_type"?: string,
            "file_metadata"?: {
                "kind"?: string,
                "id"?: string,
                "selfLink"?: string,
                "mediaLink"?: string
                "name"?: string,
                "bucket"?: string,
                "generation"?: string,
                "metageneration"?: string,
                "contentType"?: string,
                "storageClass"?: string,
                "size"?: number | null,
                "md5Hash"?: string,
                "crc32c"?: string,
                "etag"?: string,
                "timeCreated"?: string,
                "updated"?: string,
                "timeStorageClassUpdated"?: string
            },
            "resource_flag"?: boolean
        },
        {
            "thumbnail_id"?: number | null,
            "thumbnail_name"?: string,
            "thumbnail_url"?: string,
            "thumbnail_size"?: string,
            "thumbnail_type"?: string,
            "thumbnail_metadata"?: {
                "kind"?: string,
                "id"?: string,
                "selfLink"?: string,
                "mediaLink"?: string
                "name"?: string,
                "bucket"?: string,
                "generation"?: string,
                "metageneration"?: string,
                "contentType"?: string,
                "storageClass"?: string,
                "size"?: number | null,
                "md5Hash"?: string,
                "crc32c"?: string,
                "etag"?: string,
                "timeCreated"?: string,
                "updated"?: string,
                "timeStorageClassUpdated"?: string
            },
            "resource_flag"?: boolean
        }
    ],
    "resource_file_id"?: number | null,
    "thumbnail_file_id"?: number | null
}
export interface TrainingContextPayload {
    getCompanyResourceData: any
    createNewResource: any
    uploadResource: any
    deleteResource: any
    updateResource: any
    isUploading: boolean
    setIsUploading: React.Dispatch<React.SetStateAction<boolean>>
    linearShow: boolean
    setLinearShow: React.Dispatch<React.SetStateAction<boolean>>
    selectedResorceData: any
    setSelectedResorceData: React.Dispatch<React.SetStateAction<any>>
    isEditModeTrainingPage: boolean
    setIsEditModeTrainingPage: React.Dispatch<React.SetStateAction<boolean>>
    flagOpenAddNewResourceDialog: boolean
    setFlagOpenAddNewResourceDialog: React.Dispatch<React.SetStateAction<boolean>>
}

const TrainingProvider = ({ children }: ChildrenProps) => {

    const [isUploading, setIsUploading] = useState<boolean>(false);
    const [linearShow, setLinearShow] = useState<boolean>(false);
    const [selectedResorceData, setSelectedResorceData] = useState<any>({
        "resource_id": null,
        "resource_created_by_user_id": null,
        "resource_created_at_timestamp": "",
        "resource_title": "",
        "resource_description": "",
        "resource_coming_soon": false,
        "resource_file_data": [
            {
                "file_id": null,
                "file_name": "",
                "file_url": "",
                "file_size": "",
                "file_type": "",
                "file_metadata": {
                    "kind": "",
                    "id": "",
                    "selfLink": "",
                    "mediaLink": "",
                    "name": "",
                    "bucket": "",
                    "generation": "",
                    "metageneration": "",
                    "contentType": "",
                    "storageClass": "",
                    "size": null,
                    "md5Hash": "",
                    "crc32c": "",
                    "etag": "",
                    "timeCreated": "",
                    "updated": "",
                    "timeStorageClassUpdated": ""
                },
                "resource_flag": true
            },
            {
                "thumbnail_id": null,
                "thumbnail_name": "",
                "thumbnail_url": "",
                "thumbnail_size": "",
                "thumbnail_type": "",
                "thumbnail_metadata": {
                    "kind": "",
                    "id": "",
                    "selfLink": "",
                    "mediaLink": "",
                    "name": "",
                    "bucket": "",
                    "generation": "",
                    "metageneration": "",
                    "contentType": "",
                    "storageClass": "",
                    "size": null,
                    "md5Hash": "",
                    "crc32c": "",
                    "etag": "",
                    "timeCreated": "",
                    "updated": "",
                    "timeStorageClassUpdated": ""
                },
                "resource_flag": false
            }
        ]
    });
    const [isEditModeTrainingPage, setIsEditModeTrainingPage] = useState(false);
    const [flagOpenAddNewResourceDialog, setFlagOpenAddNewResourceDialog] = useState(false)

    const getCompanyResourceData = useCallback(async () => {
        const response = await agent.getCompanyResourceData.get();
        return response
    }, [])

    const createNewResource = useCallback(async (payload: CreateNewResourcePayload) => {
        const response = await agent.createNewResourceAPI.post(payload);
        return response
    }, [])

    const uploadResource = useCallback(async (payload: UploadResourcePayload) => {
        const response = await agent.uploadResourceAPI.fileUploadPost(payload)
        return response
    }, [])

    const deleteResource = useCallback(async (resource_id: string) => {
        const response = await agent.deleteResourceAPI.delete(resource_id)
        return response
    }, [])

    const updateResource = useCallback(async (payload: UpdateResourcePayload) => {
        const response = await agent.updateResourceAPI.put(payload)
        return response
    }, [])

    const payload = useMemo(() => ({
        getCompanyResourceData,
        createNewResource,
        uploadResource,
        deleteResource,
        updateResource,
        isUploading,
        setIsUploading,
        linearShow,
        setLinearShow,
        selectedResorceData,
        setSelectedResorceData,
        isEditModeTrainingPage,
        setIsEditModeTrainingPage,
        flagOpenAddNewResourceDialog,
        setFlagOpenAddNewResourceDialog
    }), [
        getCompanyResourceData,
        createNewResource,
        uploadResource,
        deleteResource,
        updateResource,
        isUploading,
        linearShow,
        selectedResorceData,
        isEditModeTrainingPage,
        flagOpenAddNewResourceDialog
    ])

    return (
        <TrainingContext.Provider value={payload}>{children}</TrainingContext.Provider>
    );
}

export { TrainingContext, TrainingProvider };
